module.exports = __webpack_public_path__ + "img/reference36.21808e7e.jpg";